



import { Component, Vue } from "vue-property-decorator";
// import $ from "jquery";
declare var $: any;
@Component({
  name: "qSlider",
  components: {},
})
export default class qSlider extends Vue {
  flexslider: any = { vars: {} };
  resizeTimerId;
  getGridSize() {
    if (window.innerWidth < 559) {
      return 2;
    }
    if (window.innerWidth < 759) {
      return 3;
    }
    if (window.innerWidth < 959) {
      return 4;
    }
    return 5;
  }
  init() {
    $(".flex-control-paging").remove();
    $(".flex-direction-nav").remove();
    $(".flexslider").removeData("flexslider").flexslider({
      prevText: "",
      nextText: "",
    });
    $(function () {
      //default
      $(".js_slide").flexslider({
        animation: "slide",
        controlsContainer: ".flex-container",
        slideshowSpeed: 8000,
        prevText: "",
        nextText: "",
      });

      //fade animation
      $(".js_fade").flexslider({
        animation: "fade",
        controlsContainer: ".flex-container",
        slideshowSpeed: 8000,
        prevText: "",
        nextText: "",
      });

      //blog list
      // store the slider in a local variable
      var $window = $(window),
        flexslider: any = { vars: {} };

      // tiny helper function to add breakpoints
      function getGridSize() {
        if (window.innerWidth < 559) {
          return 2;
        }
        if (window.innerWidth < 759) {
          return 3;
        }
        if (window.innerWidth < 959) {
          return 4;
        }
        return 5;
      }

      $window.load(function () {
        $(".flexslider").flexslider({
          slideshow: false,
          move: 1,
          slideshowSpeed: 8000,
          animation: "slide",
          animationSpeed: 400,
          prevText: "",
          nextText: "",
          animationLoop: false,
          controlNav: false,
          itemWidth: window.innerWidth / getGridSize(),
          itemMargin: 5,
          minItems: getGridSize(), // use function to pull in initial value
          maxItems: getGridSize(), // use function to pull in initial value
          start: function (slider) {
            $("body").removeClass("loading");
            flexslider = slider;
          },
        });
      });

      var resizeSlider = function () {
        var gridSize = getGridSize();

        flexslider.vars.minItems = gridSize;
        flexslider.vars.maxItems = gridSize;
      };

      var resizeTimerId = null;
      var handleResize = function () {
        clearTimeout(resizeTimerId);
        resizeTimerId = setTimeout(function () {
          resizeSlider();
        }, 1000);
      };

      // check grid size on resize event
      $window.resize(function () {
        handleResize();
      });
    });
  }
  handleResize() {
    clearTimeout(this.resizeTimerId);
    this.resizeTimerId = setTimeout(() => {
      this.resizeSlider();
    }, 1000);
  }

  resizeSlider() {
    var gridSize = this.getGridSize();

    this.flexslider.vars.minItems = gridSize;
    this.flexslider.vars.maxItems = gridSize;
  }
}
// front page
